import { render, staticRenderFns } from "./Nominees.vue?vue&type=template&id=33be7baf&"
import script from "./Nominees.vue?vue&type=script&lang=js&"
export * from "./Nominees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports